import Cleave from 'cleave.js'
require('cleave.js/dist/addons/cleave-phone.us')

export const FormatterUtils = {
  methods: {
    isTrue (setting) {
      return String(setting) === 'true'
    },
    applyDateFormat (nameAttribute) {
      return new Cleave('[name="' + nameAttribute + '"]', {
        date: true,
        delimiter: '/',
        datePattern: ['m', 'd', 'Y']
      })
    },
    applyPhoneFormat (nameAttribute) {
      return new Cleave('[name="' + nameAttribute + '"]', {
        delimiters: ['(', ')', ' ', '-'],
        blocks: [0, 3, 0, 3, 4]
      })
    },
    registrationQuestionsFormatter (question) {
      if (question.clarification && question.clarification.length > 0) {
        this.toggleClarificationQuestions(question)
      }
    },
    checkIfAnswerIsYes (question, q) {
      if (question.answer.toLowerCase() === 'yes') {
        this.$store.state.questions[q].used_for = '1'
        this.$store.state.questions[q].display = 1
      } else {
        this.$store.state.questions[q].used_for = '5'
        this.$store.state.questions[q].display = 0
      }
    },
    /**
     * Show/Hides the: "If yes, then date of symptom onset" field if the Question: "Symptomatic as defined by CDC?" 's answer is Yes
     * @param question
       */
    toggleClarificationQuestions (question) {
      if (question.clarification && question.clarification.length > 0) {
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if (question.clarification.indexOf(',') !== -1) {
            let arr = question.clarification.split(',')
            for (let i = 0; i < arr.length; i++) {
              if (this.$store.state.questions[q].id === arr[i]) {
                this.checkIfAnswerIsYes(question, q)
              }
            }
          } else {
            if (this.$store.state.questions[q].id === question.clarification) {
              this.checkIfAnswerIsYes(question, q)
            }
          }
        }
      }
    },
    /**
     * Fix datepicker chrome issue that didn't allow to remove not-a-number characters on backspace key press
     * @param target
     * @returns {*}
       */
    cleaveBackspaceFix (target) {
      if (isNaN(target.value.slice(-1))) {
        target.value = target.value.slice(0, -1)
      }
      return target.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Formatter.js